import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import defaultThemeData from 'components/sharpr/theme/defaultThemeData';
import _ from 'lodash';

let themeData = _.clone(defaultThemeData);

let customCssElement = AssetManager.style('');
customCssElement.setAttribute('id', 'CustomCss');

/** @ignore */
export function ThemeResolves(resolves) {
	resolves.__themesData = (Api, $rootScope) => {
		'ngInject';
		return Api.get('/themes/current', {}, { cacheFor: 30 * 60 * 1000 }).then(data => {
			$rootScope.$appname = data.appname;
			ThemeService.apply(data);
			return data;
		});
	};
}

/**
 * Get information about the current theme
 */
export class ThemeService {
	/**
	 *
	 * @param {ApiService} Api instance of ApiService for XHR calls
	 */
	constructor(Api, $rootScope) {
		'ngInject';
		/**
		 * The Api Service
		 * @type {ApiService}
		 */
		this.Api = Api;
		this.$rootScope = $rootScope;
		/**
		 * Make `ThemeService.apply` an instance method too
		 * @type {Function}
		 */
		this.apply = ThemeService.apply;
	}

	data() {
		return themeData;
	}

	/**
	 * Get the 6-letter theme code
	 * @returns {String}
	 */
	code() {
		return themeData ? themeData.code : 'sharpr';
	}

	/**
	 * Get the theme version string
	 * @returns {String}
	 */
	v() {
		return themeData ? themeData.v : '0';
	}

	/**
	 * Get the full url to the given themed image
	 * @param {String} name  Either "on-light.png" or "on-dark.png"
	 * @returns {String}
	 */
	img(name) {
		return `${window.BASE_URL}/assets/theme/${this.code()}/${name}?v=${this.v()}`;
	}

	/**
	 * Load the given theme data
	 * @param {Object} data  Data from GET /themes/data
	 * @param {Boolean} updateHeader  True if the header logo should be updated
	 * @returns {Promise}  A promise that will resolve when the theme CSS is loaded
	 */
	static apply(data, updateHeader = false) {
		if (!data) {
			return Promise.resolve(null);
		}
		if (!themeData) {
			themeData = {};
		}
		// allow updating some properties but not all properties
		// which is what happens on view post full-screen modal
		Object.assign(themeData, data);
		// remove old class names (e.g. because our cache expired)
		AssetManager.removeDocClass('theme-base-*');
		AssetManager.removeDocClass('app-solution-*');
		// add new class names
		AssetManager.addDocClass('theme-base-' + themeData.header);
		var solution = themeData.solution || 'agency';
		AssetManager.addDocClass('app-solution-' + solution);
		// remove themed css if already present (e.g. because our cache expired)
		AssetManager.removeElement('link[href*="/angular/assets/css/themed.php"]');
		// include the themed css
		const promise = AssetManager.css(
			`${window.BASE_URL}/angular/assets/css/themed.php` +
				'?code=' +
				encodeURIComponent(themeData.code) +
				'&base_style=' +
				encodeURIComponent(themeData.header) +
				'&color_bubble=' +
				encodeURIComponent(themeData.bubble) +
				'&color1=' +
				encodeURIComponent(themeData.link1) +
				'&color2=' +
				encodeURIComponent(themeData.link2) +
				'&color_button_accent=' +
				encodeURIComponent(themeData.button1) +
				'&color_bubble2=' +
				encodeURIComponent(themeData.button2) +
				'&v=' +
				encodeURIComponent(themeData.v)
		);
		if (updateHeader) {
			const logoUrl = themeData.header == 'white' ? themeData.on_light_url : themeData.on_dark_url;
			AssetManager.removeElement('.header-logo-image');
			AssetManager.createAndAppendElement('img', { src: logoUrl, classNames: ['header-logo-image'] }, '.header-logo');
		}

		// include custom css and ensure it is the last stylesheet in the document
		customCssElement.textContent = themeData.custom_css || '';
		document.head.appendChild(customCssElement);
		// promise will resolve when themed css is loaded
		return promise;
	}

	/**
	 * Fetch theme data for a this hub
	 */
	load() {
		return this.Api.get(`/themes/current`, {}, { avoidLoadingBar: true }).then(data => {
			if (!data || !data.bubble) {
				data = _.clone(defaultThemeData);
			}
			return ThemeService.apply(data).then(() => {
				this.$rootScope.$appname = data.appname;
			});
		});
	}
}
